import { CheckCircle2 } from "lucide-react";
import { STATUS_LABELS, STATUS_COLORS, STATUS_FLOW } from "../lib/api";

export function StatusBadge({ status }) {
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${STATUS_COLORS[status] || STATUS_COLORS.submitted}`}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export function CaseTimeline({ history }) {
  const items = [...(history || [])].reverse();
  return (
    <div className="relative" data-testid="case-timeline">
      {items.map((h, i) => (
        <div key={`${h.at}-${h.status}-${i}`} className="relative grid grid-cols-[auto_1fr] gap-4 pb-6 last:pb-0">
          {i < items.length - 1 && <span className="absolute left-[11px] top-6 bottom-0 w-px bg-slate-200" aria-hidden="true" />}
          <div className={`relative z-10 h-6 w-6 rounded-full flex items-center justify-center shrink-0 ${i === 0 ? "bg-cyan-100 ring-4 ring-cyan-50" : "bg-slate-100"}`}>
            {i === 0 ? (
              <span className="h-2.5 w-2.5 rounded-full bg-cyan-500 animate-pulse" />
            ) : (
              <CheckCircle2 className="h-4 w-4 text-slate-400" />
            )}
          </div>
          <div className="-mt-0.5">
            <p className={`text-sm font-semibold ${i === 0 ? "text-slate-900" : "text-slate-600"}`}>
              {STATUS_LABELS[h.status] || h.status}
            </p>
            <p className="text-xs text-slate-400 mt-0.5">
              {new Date(h.at).toLocaleString()} · {h.by}
            </p>
            {h.note && <p className="text-xs text-slate-500 mt-1.5 bg-slate-50 border border-slate-100 rounded-lg px-3 py-2">{h.note}</p>}
          </div>
        </div>
      ))}
    </div>
  );
}

export function StatusProgress({ status }) {
  const idx = STATUS_FLOW.indexOf(status);
  const mainFlow = STATUS_FLOW.filter((s) => s !== "revision_requested");
  const mainIdx = mainFlow.indexOf(status === "revision_requested" ? "doctor_review" : status);
  return (
    <div className="flex items-center gap-1" data-testid="status-progress" aria-hidden="true">
      {mainFlow.map((s, i) => (
        <span key={s} className={`h-1.5 flex-1 rounded-full ${i <= mainIdx ? (status === "revision_requested" ? "bg-red-400" : "bg-cyan-500") : "bg-slate-200"}`} />
      ))}
      {idx === -1 && null}
    </div>
  );
}
